module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "events",
    staticClass: "event-gallery"
  }, [_c('StartPageSlider', {
    attrs: {
      "line-title-color": "#279DF2",
      "title": "ПРОГРАММЫ ОБУЧЕНИЯ ДЛЯ КАЖДОГО",
      "flex-wrap": "true"
    }
  }, _vm._l((_vm.data.slice(0, Math.min(_vm.data.length, 8))), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "event-card d-flex flex-column",
      attrs: {
        "tag": "div",
        "to": {
          name: "event-card",
          params: {
            id: item.id,
            code: item.url_code
          }
        }
      }
    }, [_c('div', {
      staticClass: "event-card_photo--wrapper"
    }, [_c('AppPicture', {
      attrs: {
        "image": item.image ? item.image.big : "",
        "fit-mode": "contain",
        "border-radius": "20px",
        "background-color": "inherit",
        "ratio": "3 / 2"
      }
    })], 1), _c('div', {
      staticClass: "event-card__title d-flex"
    }, [_c('span', {
      staticClass: "ui_lines-limit-4"
    }, [_vm._v(_vm._s(item.name))])]), _c('div', {
      staticClass: "event-card__description d-flex"
    }, [_c('span', {
      staticClass: "ui_lines-limit-4"
    }, [_vm._v(_vm._s(item.announce))])]), _c('div', {
      staticClass: "event-card__tools-pannel d-flex"
    }, [_c('span', {
      staticClass: "d-flex event-card__duration"
    }, [_c('AppSvgIcon', {
      staticClass: "d-flex clock-icon",
      attrs: {
        "icon-name": _vm.$ui.IconSvgName.clock
      }
    }), _vm._v(_vm._s(_vm.getText(Number(item.labor_program), 'час', ['', 'а', 'ов'])) + " " + _vm._s(item.length_text))], 1)])])
  }), 1), _c('AppButtonNew', {
    staticClass: "choose_button",
    attrs: {
      "type": _vm.getButtonType.big_button_stroke,
      "to": "/directivities"
    }
  }, [_vm._v("ВЫБРАТЬ ИЗ " + _vm._s(_vm.getProgramsLength) + " ПРОГРАММ"), _c('AppSvgIcon', {
    staticClass: "iconProgram",
    attrs: {
      "icon-name": _vm.$ui.IconSvgName.arrowLeft,
      "fill": "rgba(7, 124, 187, 1)"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a917637","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/events/Events.vue
// module id = 9dc6ae41ef548eb49a53
// module chunks = 0